import styled from 'styled-components';
const ETEModalStyle = styled.div`
  > div > div {
    ${({
  mode,
  pagesWithNoFooter
}) => mode === 'page' && !pagesWithNoFooter ? `
      border: 1px solid #ccc;
      min-height: 700px;
      max-width: 550px;
      min-width: 320px;
      position: relative !important;
      background-color: transparent;
      -moz-transition: 0.2s;
      -ms-transition: 0.2s;
      -o-transition: 0.2s;
      -webkit-transition: 0.2s;
      transition: 0.2s ease-in-out;
      overflow: 'hidden';
    ` : `
      border: 1px solid #ccc;
      min-height: 700px !important;
      max-width: 550px;
      min-width: 320px;
      position: relative !important;
      background-color: transparent;
      -moz-transition: 0s;
      -ms-transition: 0s;
      -o-transition: 0s;
      -webkit-transition: 0s;
      transition: 0s;
      overflow: 'hidden';
    `}

    ${({
  mode
}) => mode === 'modal' && `
      border: 0px;
    `}

    ${({
  visitedNoFooterPage
}) => visitedNoFooterPage && `
      -moz-transition: 0s;
      -ms-transition: 0s;
      -o-transition: 0s;
      -webkit-transition: 0s;
      transition: 0s;
      overflow: 'hidden';
    `}

    ${({
  mode,
  expandForGAC
}) => mode === 'page' && expandForGAC && `
      min-height: 770px;
    `}
    // HULA - extend outer <div> element.
    ${({
  mode,
  expandForHULA
}) => mode === 'page' && expandForHULA && `
        min-height: 820px;
    `}

    ${({
  mode,
  expand,
  pagesWithNoFooter
}) => mode === 'page' && expand && !pagesWithNoFooter && `
      min-height: 880px;
    `}

    z-index: 1;
    outline: none !important;

    /**
     * <article> is Modal window.
    */
    > article {
      width: 100%;
      max-height: 100%;
      max-width: 550px;
      min-height: 700px;
      border: 1px solid #ccc;
      background-color: transparent;
      ${({
  pagesWithNoFooter
}) => !pagesWithNoFooter ? `
        -moz-transition: 0.2s;
        -ms-transition: 0.2s;
        -o-transition: 0.2s;
        -webkit-transition: 0.2s;
        transition: 0.2s ease-in-out;
        overflow: 'hidden';
      ` : `
        min-height: 700px !important
        -moz-transition: 0s;
        -ms-transition: 0s;
        -o-transition: 0s;
        -webkit-transition: 0s;
        transition: 0s;
        overflow: 'hidden';
      `};

      // when user comes back after visiting create a case on page version.
      ${({
  visitedNoFooterPage
}) => visitedNoFooterPage && `
        -moz-transition: 0s;
        -ms-transition: 0s;
        -o-transition: 0s;
        -webkit-transition: 0s;
        transition: 0s;
        overflow: 'hidden';
      `}

      ${({
  mode,
  expandForGAC
}) => mode === 'page' && expandForGAC && `
        min-height: 770px;
      `}
      // // HULA - extend <article> element.
      ${({
  mode,
  expandForHULA
}) => mode === 'page' && expandForHULA && `
        min-height: 820px;
      `}

    ${({
  mode,
  expand,
  expandForGAC,
  pagesWithNoFooter
}) => mode === 'page' && expand && !pagesWithNoFooter && !expandForGAC && `
      min-height: 880px;
    `}

    // GAC - when you click on Footer for help options.
    ${({
  mode,
  expand,
  expandForGAC,
  pagesWithNoFooter
}) => mode === 'page' && expand && !pagesWithNoFooter && expandForGAC && `
      min-height: 960px;
    `}

    // HULA - when you click on Footer for help options.
    ${({
  mode,
  expand,
  expandForHULA,
  pagesWithNoFooter
}) => mode === 'page' && expand && !pagesWithNoFooter && expandForHULA && `
      min-height: 1000px;
    `}

    ${({
  mode,
  expandForGAC,
  pagesWithNoFooter,
  expand
}) => mode === 'page' && expandForGAC && !pagesWithNoFooter && !expand && `
      min-height: 780px !important;
    `}

    ${({
  mode
}) => mode === 'page' && `
        top: 0px;
        position: relative;
        box-shadow: 0 0 black;
      `}

      > header {
        font-weight: 100;
        font-size: 30px;
        line-hight: 35px;

        // Add margin to have Spinner in middle of the page during submission of request.
        ${({
  curPage
}) => curPage === 'processSpinPage' && `
          margin-bottom: 100px;
        `}

        ${({
  showHeader
}) => !showHeader ? `
          border-bottom: transparent;
          margin-bottom: 100px;
        ` : `
          border-bottom: 1px solid rgba(60, 60, 60, 0.25);
        `}

        > div {
          padding: 30px 30px 20px;
          margin: 0px 0px 0px;

          /**
           * Remove X close button for Page version ETEModal.
          */
          > button {
            ${({
  mode
}) => mode === 'page' && `
              display: none;
            `}
          }
        }
      }

      > section > div {
        padding: 25px 30px 30px 30px;
      }
    }
  }

  /**
   * When we open Modal in AVA from 570 pixel, it takes full width and height.
   * link: https://ava-stg.autodesk.com/
  */
  @media (max-width: 570px) {
    div > div > article {
      ${({
  mode
}) => mode === 'modal' && `
          position: fixed;
          top: 0%;
          left: 50%;
          bottom: 0%;
          right: 0%;
          height: 100%;
        `}
    }
  }
`;
export default ETEModalStyle;